import { PayVehicle } from '../components/ReservationNvvEdit'
import { TradeIn } from '../interfaces/Reservation'
import Vehicle from '../interfaces/Vehicle'

import { formatWithThousandSep } from './utils'

export const tradeInToPaycost = (trades: TradeIn[], tradeInVehicles: Vehicle[]): PayVehicle[] => {
  return trades.map((trade) => ({
    key: trade._id,
    price: trade.price, // mapping 'price' to 'cost'
    description: getTradeVehicleDesc(trade.vehicle, tradeInVehicles), // same field names
    date: '', // same field names
    price_format: formatWithThousandSep(trade.price),
    vehicle: getTradeVehicle(trade.vehicle, tradeInVehicles),
  }))
}
// Obtenemos el dato desde la lista de vehiculos que viene dese la
// base con el reservation

const getTradeVehicle = (vehicleId: string, tradeInVehicles: Vehicle[]): Vehicle | null => {
  const vehicles = (tradeInVehicles ?? []).filter((v): v is Vehicle => v._id === vehicleId)

  if (!vehicles) return null

  if (vehicles.length === 0) return null
  const veh = vehicles[0]

  return veh
}

// Obtenemos el dato desde la lista de vehiculos que viene dese la
// base con el reservation
const getTradeVehicleDesc = (vehicleId: string, tradeInVehicles: Vehicle[]): string => {
  const vehicle = getTradeVehicle(vehicleId, tradeInVehicles ?? [])

  if (!vehicle) return 'desconocido'

  return vehicleMakeDescription(vehicle)
}
export const vehicleMakeDescription = (vehicle: Vehicle | null): string => {
  return vehicle && vehicle !== null
    ? `${vehicle?.year} ${vehicle?.brand} ${vehicle?.model} ${vehicle?.version} ${vehicle?.color} [${vehicle?.plate}]`
    : 'desconocido'
}

export const transformToTradeIn = (payCosts: PayVehicle[]): TradeIn[] => {
  return payCosts.map((payCost) => ({
    _id: payCost.key.toString(),
    price: payCost.price, // mapping 'price' to 'cost'
    vehicle: payCost.vehicle?._id ?? '', // va el _id del vehiculo
  }))
}
export const generatePayVehicle = (): PayVehicle => ({
  key: Math.floor(Math.random() * 1000000).toString(),
  description: '',
  price: 0,
  price_format: '',
})
